// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Ulrich Mierendorff
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : Database Administration and Debugging Parts
// =============================================================================
import { treeAspect, isRootDomainConfig, isDomainRecord } from 'uix/views/utils';
export const database = {
    ...treeAspect,
    tabGroup: 'database',
    acl: 'g:debug',
    cfg: isRootDomainConfig,
    enabled: isDomainRecord,
    tabs: {
        start: {
            default: true,
            tabGroupDefault: true,
            parts: [
                'DatabaseDashboard'
            ]
        },
        cmd: {
            parts: [
                'DatabaseCommand'
            ]
        },
        stats: {
            parts: [
                'DatabaseTableStats'
            ]
        },
        index: {
            parts: [
                'DatabaseIndexes'
            ]
        },
        activities: {
            parts: [
                'DatabaseActivities'
            ]
        },
        schema: {
            parts: [
                'DatabaseSchema'
            ]
        },
        backup: {
            parts: [
                'DatabaseBackup'
            ]
        },
        updates: {
            parts: [
                'DatabaseUpdates'
            ]
        }
    }
};
